initCartDrawer();

function initCartDrawer() {
  document.querySelector('.shopify-section-cart-drawer').addEventListener('click', (event) => {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element?.getAttribute('data-click-action');

      if (clickAction === 'close-cart-drawer') {
        closeCartDrawerHandler(element);
        window.mx.showGorgiasButton();
        break;
      } else if (clickAction === 'remove-item-from-cart') {
        removeItemFromCartHandler(element);
        break;
      } else if (clickAction === 'set-coupon-code') {
        setCouponCodeHandler(element);
        break;
      }
    }
  });

  document.querySelector('.shopify-section-cart-drawer').addEventListener('focusin', (event) => {
    event.target.addEventListener('keyup', handleCouponConfirmation);
  });

  document.querySelector('.mx-cart-drawer').addEventListener('focusout', (event) => {
    event.target.removeEventListener('keyup', handleCouponConfirmation);
  });

  // loadRecommendedProducts();
}

async function loadRecommendedProducts() {
  try {
    const cartRecommendationsContainer = document.querySelector('.cart-recommendations-container');
    const cartRecommendationsEndpoint = cartRecommendationsContainer.dataset.url;

    const cartRecommendationsMarkup = await fetch(cartRecommendationsEndpoint).then((response) => response.text());

    const parser = new DOMParser();
    const newCartRecommendationsContainer = parser
      .parseFromString(cartRecommendationsMarkup, 'text/html')
      .querySelector('.cart-recommendations-container');

    cartRecommendationsContainer.innerHTML = newCartRecommendationsContainer.innerHTML;
  } catch (error) {
    console.error(error);
  }
}

function closeCartDrawerHandler(closeButton) {
  closeButton.closest('.shopify-section-cart-drawer').querySelector('.mx-cart-drawer').removeAttribute('data-open');
  document.documentElement.removeAttribute('data-locked');
  window.scrollTo(0, -1 * parseInt(document.documentElement.style.top));
  document.documentElement.style.top = null;
  document.documentElement.style.scrollBehavior = null;
}

async function removeItemFromCartHandler(removeButton) {
  const itemKey = removeButton.closest('.cart-item-container').getAttribute('data-line-key');

  const sectionId = removeButton.closest('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

  try {
    const cartUpdateJson = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [itemKey]: 0,
        },
        sections: [sectionId],
      }),
    }).then((response) => response.json());

    refreshCartUserInterface(cartUpdateJson.sections[sectionId]);
  } catch (error) {
    console.error('Error removing the product from cart', error);
  }
}

async function setCouponCodeHandler(applyCouponButton) {
  const couponInput = applyCouponButton.previousElementSibling;

  const couponCode = couponInput.value.toUpperCase();
  const couponCodeLoadingString = applyCouponButton.parentElement.getAttribute('data-loading-string');

  couponInput.value = '';
  couponInput.placeholder = couponCodeLoadingString;
  couponInput.blur();

  if (couponCode === null) return;

  try {
    await fetch('/discount/' + couponCode);

    const sectionId = applyCouponButton.closest('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

    const sectionJson = await fetch(`/?sections=${sectionId}`).then((response) => response.json());

    refreshCartUserInterface(sectionJson[sectionId]);
  } catch (error) {
    console.error('Error applying the coupon code', error);
  }
}

function refreshCartUserInterface(sectionMarkup) {
  const sectionHtml = new DOMParser().parseFromString(sectionMarkup, 'text/html');

  const cartDrawer = document.querySelector('.mx-cart-drawer');
  const newCartDrawer = sectionHtml.querySelector('.mx-cart-drawer');

  const newCartItemCount = newCartDrawer.getAttribute('data-cart-item-count');
  document.querySelectorAll('[data-cart-item-count]').forEach((element) => {
    element.setAttribute('data-cart-item-count', newCartItemCount);
  });

  cartDrawer.replaceChildren(...newCartDrawer.children);
}

function handleCouponConfirmation(event) {
  if (event.key === 'Enter') {
    setCouponCodeHandler(event.target.nextElementSibling);
  }
}
